import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { GripVertical } from "lucide-react";
import * as ResizablePrimitive from "react-resizable-panels";
import { cn } from "../../../utils";
const ResizablePanelGroup = ({ className, ...props })=>/*#__PURE__*/ _jsx(ResizablePrimitive.Group, {
        className: cn("flex h-full w-full", className),
        ...props
    });
const ResizablePanel = ResizablePrimitive.Panel;
// A separator in a horizontal group is a vertical divider and vice versa, so
// the aria-orientation v4 renders is the flip of the group orientation: the
// `aria-[orientation=horizontal]` variants below style vertical groups.
const ResizableHandle = ({ withHandle, className, ...props })=>/*#__PURE__*/ _jsx(ResizablePrimitive.Separator, {
        className: cn("relative flex w-px items-center justify-center bg-border cursor-col-resize after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 aria-[orientation=horizontal]:h-px aria-[orientation=horizontal]:w-full aria-[orientation=horizontal]:cursor-row-resize aria-[orientation=horizontal]:after:left-0 aria-[orientation=horizontal]:after:h-1 aria-[orientation=horizontal]:after:w-full aria-[orientation=horizontal]:after:-translate-y-1/2 aria-[orientation=horizontal]:after:translate-x-0 [&[aria-orientation=horizontal]>div]:rotate-90", className),
        ...props,
        children: withHandle && /*#__PURE__*/ _jsx("div", {
            className: "z-10 flex h-4 w-3 items-center justify-center rounded-sm border bg-border",
            children: /*#__PURE__*/ _jsx(GripVertical, {
                className: "h-2.5 w-2.5"
            })
        })
    });
export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
// Consumers size, collapse, and persist panels through the library's own
// surface; re-exported so no app has to declare a direct dependency on
// react-resizable-panels.
export { useDefaultLayout } from "react-resizable-panels";

//# sourceMappingURL=resizable.js.map